import { render, staticRenderFns } from "./AdminSideNavLayout.vue?vue&type=template&id=81cdc046&"
import script from "./AdminSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports